import { Injectable } from '@angular/core';
import { BaseViewModel } from '../../../../models/base/base-view-model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class SmartFiltersSectionViewModel extends BaseViewModel {
  private _smartFilterIds = new BehaviorSubject<string[]>([]);
  public smartFilterIds$ = this._smartFilterIds as Observable<string[]>;

  setSmartFilterIds(ids: string[]) {
    this._smartFilterIds.next(ids);
  }
}
